import './polyfills';
import { h, render } from 'preact';
import App from './components/App/App';
render(h(App, { name: "StarsRewards Widget" }), document.querySelector('[stars-rewards]'));
